window.theme = window.theme || {};

theme.PredictiveSearch = (function() {
  var DEBOUNCE_MS = 300;
  var SECTION_ID = 'predictive-search';
  var cachedResults = {};
  var instances = [];
  var documentEventsBound = false;

  var selectors = {
    container: '[data-predictive-search]',
    input: '[data-predictive-search-input]',
    results: '[data-predictive-search-results]',
    clear: '[data-predictive-search-clear]',
    status: '.predictive-search-status',
    searchDrawer: '#SearchDrawer',
    siteHeader: '.site-header'
  };

  var classes = {
    hidden: 'hide',
    open: 'predictive-search--open'
  };

  function init() {
    $(selectors.container).each(function() {
      initContainer($(this));
    });

    if (!documentEventsBound) {
      bindDocumentEvents();
      documentEventsBound = true;
    }
  }

  function initContainer($container) {
    var $input = $container.find(selectors.input);
    var $results = $container.find(selectors.results);
    var $clear = $container.find(selectors.clear);
    var $form = $input.closest('form');
    var $status = $container.find(selectors.status);

    var state = {
      $container: $container,
      $input: $input,
      $results: $results,
      $clear: $clear,
      $form: $form,
      $status: $status,
      debounceTimer: null,
      abortController: new AbortController(),
      searchTerm: '',
      isOpen: false,
      resultsMaxHeight: false,
      loadingText:
        $container.attr('data-loading-text') ||
        (theme.stringsPredictiveSearch && theme.stringsPredictiveSearch.loading) ||
        'Loading'
    };

    instances.push(state);

    $input.on(
      'input',
      debounce(function() {
        onChange(state);
      }, DEBOUNCE_MS)
    );

    $clear.on('click', function(evt) {
      evt.preventDefault();
      $input.val('').trigger('focus');
      toggleClearButton(state);
      state.searchTerm = '';
      state.abortController.abort();
      state.abortController = new AbortController();
      closeResults(state, true);
    });

    $input.on('focus', function() {
      onFocus(state);
    });

    $container.on('focusout', function() {
      onFocusOut(state);
    });

    $input.on('keydown', function(evt) {
      onKeydown(state, evt);
    });

    $input.on('keyup', function(evt) {
      onKeyup(state, evt);
    });

    $form.on('submit', function(evt) {
      onFormSubmit(state, evt);
    });

    $results.on('click', 'a', function() {
      closeResults(state);
    });
  }

  function debounce(fn, wait) {
    var timeout;
    return function() {
      var context = this;
      var args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(function() {
        fn.apply(context, args);
      }, wait);
    };
  }

  function getQuery(state) {
    return state.$input.val().trim();
  }

  function getQueryKey(searchTerm) {
    return searchTerm.replace(/ /g, '-').toLowerCase();
  }

  function getPredictiveSearchUrl() {
    if (theme.routes && theme.routes.predictive_search_url) {
      return theme.routes.predictive_search_url;
    }

    return '/search/suggest';
  }

  function onChange(state) {
    toggleClearButton(state);

    var newSearchTerm = getQuery(state);

    if (!state.searchTerm || !newSearchTerm.startsWith(state.searchTerm)) {
      state.$results.find('.predictive-search__list').remove();
    }

    updateSearchForTerm(state, state.searchTerm, newSearchTerm);
    state.searchTerm = newSearchTerm;

    if (!state.searchTerm.length) {
      closeResults(state, true);
      return;
    }

    getSearchResults(state, state.searchTerm);
  }

  function onFocus(state) {
    var currentSearchTerm = getQuery(state);

    if (!currentSearchTerm.length) {
      return;
    }

    if (state.searchTerm !== currentSearchTerm) {
      onChange(state);
    } else if (state.$container.attr('data-results') === 'true') {
      openResults(state);
    } else {
      getSearchResults(state, state.searchTerm);
    }
  }

  function onFocusOut(state) {
    setTimeout(function() {
      if (!state.$container[0].contains(document.activeElement)) {
        closeResults(state);
      }
    });
  }

  function onKeydown(state, evt) {
    if (evt.key === 'ArrowUp' || evt.key === 'ArrowDown') {
      evt.preventDefault();
    }

    if (evt.key === 'Escape') {
      closeResults(state);
    }
  }

  function onKeyup(state, evt) {
    if (!getQuery(state).length) {
      closeResults(state, true);
    }

    switch (evt.key) {
      case 'ArrowUp':
        switchOption(state, 'up');
        break;
      case 'ArrowDown':
        switchOption(state, 'down');
        break;
      case 'Enter':
        selectOption(state);
        break;
      default:
        break;
    }
  }

  function onFormSubmit(state, evt) {
    if (
      !getQuery(state).length ||
      state.$results.find('[aria-selected="true"] a').length
    ) {
      evt.preventDefault();
    }
  }

  function updateSearchForTerm(state, previousTerm, newTerm) {
    var $searchForText = state.$results.find('[data-predictive-search-search-for-text]');

    if (!$searchForText.length || !previousTerm) {
      return;
    }

    var currentButtonText = $searchForText.text();
    var matches = currentButtonText.match(new RegExp(escapeRegExp(previousTerm), 'g'));

    if (matches && matches.length > 1) {
      return;
    }

    $searchForText.text(currentButtonText.replace(previousTerm, newTerm));
  }

  function escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function switchOption(state, direction) {
    if (!state.$container.hasClass(classes.open)) {
      return;
    }

    var moveUp = direction === 'up';
    var $selected = state.$results.find('[aria-selected="true"]');
    var $allVisible = state.$results.find('li[role="option"], button[role="option"]').filter(function() {
      return this.offsetParent !== null;
    });

    if (!$allVisible.length) {
      return;
    }

    if (moveUp && !$selected.length) {
      return;
    }

    var selectedIndex = $allVisible.index($selected);
    var activeIndex = 0;

    if (!moveUp && $selected.length) {
      activeIndex = selectedIndex === $allVisible.length - 1 ? 0 : selectedIndex + 1;
    } else if (moveUp) {
      activeIndex = selectedIndex === 0 ? $allVisible.length - 1 : selectedIndex - 1;
    }

    if (activeIndex === selectedIndex) {
      return;
    }

    $selected.attr('aria-selected', 'false');
    var $active = $allVisible.eq(activeIndex);
    $active.attr('aria-selected', 'true');
    state.$input.attr('aria-activedescendant', $active.attr('id') || '');
  }

  function selectOption(state) {
    var $selected = state.$results.find('[aria-selected="true"] a, button[aria-selected="true"]');

    if ($selected.length) {
      $selected[0].click();
    }
  }

  function getSearchResults(state, searchTerm) {
    var queryKey = getQueryKey(searchTerm);
    setLiveRegionLoadingState(state);

    if (cachedResults[queryKey]) {
      renderSearchResults(state, cachedResults[queryKey]);
      return;
    }

    state.abortController.abort();
    state.abortController = new AbortController();

    var url =
      getPredictiveSearchUrl() +
      '?q=' +
      encodeURIComponent(searchTerm) +
      '&section_id=' +
      SECTION_ID;

    fetch(url, { signal: state.abortController.signal })
      .then(function(response) {
        if (!response.ok) {
          closeResults(state);
          throw new Error(response.status);
        }

        return response.text();
      })
      .then(function(text) {
        var parsed = new DOMParser().parseFromString(text, 'text/html');
        var section = parsed.querySelector('#shopify-section-' + SECTION_ID);

        if (!section) {
          closeResults(state);
          return;
        }

        var resultsMarkup = section.innerHTML;
        cachedResults[queryKey] = resultsMarkup;
        renderSearchResults(state, resultsMarkup);
      })
      .catch(function(error) {
        if (error && error.name === 'AbortError') {
          return;
        }

        closeResults(state);
      });
  }

  function setLiveRegionLoadingState(state) {
    if (!state.$status.length) {
      return;
    }

    state.$status.attr('aria-hidden', 'false').text(state.loadingText);
    state.$container.attr('data-loading', 'true');
  }

  function setLiveRegionText(state, statusText) {
    if (!state.$status.length) {
      return;
    }

    state.$status.attr('aria-hidden', 'false').text(statusText);

    setTimeout(function() {
      state.$status.attr('aria-hidden', 'true');
    }, 1000);
  }

  function renderSearchResults(state, resultsMarkup) {
    if (!resultsMarkup.trim()) {
      closeResults(state);
      return;
    }

    state.$results.html(resultsMarkup);
    state.$container.attr('data-results', 'true');
    state.$container.removeAttr('data-loading');

    var $liveRegion = state.$results.find('[data-predictive-search-live-region-count-value]');
    if ($liveRegion.length) {
      setLiveRegionText(state, $liveRegion.text());
    }

    openResults(state);
  }

  function getResultsMaxHeight(state) {
    if (state.$container.closest(selectors.searchDrawer).length) {
      return window.innerHeight - state.$container[0].getBoundingClientRect().bottom - 16;
    }

    var $header = $(selectors.siteHeader);
    var headerBottom = $header.length ? $header[0].getBoundingClientRect().bottom : 0;
    return window.innerHeight - headerBottom;
  }

  function openResults(state) {
    var isDrawer = state.$container.closest(selectors.searchDrawer).length;

    if (!isDrawer) {
      state.resultsMaxHeight = state.resultsMaxHeight || getResultsMaxHeight(state);
      state.$results.css('max-height', state.resultsMaxHeight + 'px');
    }

    state.$results.removeClass(classes.hidden);
    state.$container.addClass(classes.open);
    state.isOpen = true;

    if (state.$container.closest(selectors.searchDrawer).length) {
      $(selectors.searchDrawer).addClass(classes.open);
    }

    state.$input.attr('aria-expanded', 'true');
  }

  function closeResults(state, clearSearchTerm) {
    if (clearSearchTerm) {
      state.$input.val('');
      state.$container.removeAttr('data-results');
      state.searchTerm = '';
      toggleClearButton(state);
    }

    state.$results.find('[aria-selected="true"]').attr('aria-selected', 'false');
    state.$input.attr('aria-activedescendant', '');
    state.$container.removeAttr('data-loading');
    state.$results.addClass(classes.hidden).empty();
    state.$container.removeClass(classes.open);
    state.isOpen = false;
    state.resultsMaxHeight = false;
    state.$results.removeAttr('style');

    if (state.$container.closest(selectors.searchDrawer).length) {
      $(selectors.searchDrawer).removeClass(classes.open);
    }

    state.$input.attr('aria-expanded', 'false');
  }

  function toggleClearButton(state) {
    if (state.$input.val().trim().length > 0) {
      state.$clear.removeClass(classes.hidden);
    } else {
      state.$clear.addClass(classes.hidden);
    }
  }

  function bindDocumentEvents() {
    if (window.MutationObserver && $(selectors.searchDrawer).length) {
      var observer = new MutationObserver(function() {
        if (!document.body.classList.contains('js-drawer-open-top')) {
          instances.forEach(function(state) {
            if (state.$container.closest(selectors.searchDrawer).length) {
              closeResults(state);
            }
          });
        }
      });

      observer.observe(document.body, {
        attributes: true,
        attributeFilter: ['class']
      });
    }
  }

  return {
    init: init
  };
})();

$(function() {
  theme.PredictiveSearch.init();
});
